
function applicantResolver(BXDataService, $transition$) {
  
    let applicantId = $transition$.params().applicantId;

    return BXDataService.getApplicant(applicantId);
}

applicantResolver.$inject = ['BXDataService', '$transition$'];


const applicantEditIndex = {
    name: 'applicant',
    url: 'my-applicants/applicant/{applicantId}/',
    component: 'applicant',

    resolve: {
        applicant: applicantResolver
    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./my-applicants.module")
        .then(mod => $ocLazyLoad.load(mod.MY_APPLICANTS_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }
};

  
const applicantEditIndividual = {
    name: 'applicant.individual',
    url: 'individual/',
    component: 'applicantIndividual',
    
    resolve: {},

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./my-applicants.module")
        .then(mod => $ocLazyLoad.load(mod.MY_APPLICANTS_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }
};

    
const applicantEditSelfEmployed = {
    name: 'applicant.self-employed',
    url: 'self-employed/',
    component: 'applicantSelfEmployed',
    text: 'Создать заявителя - ИП',
    
    resolve: {},

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./my-applicants.module")
        .then(mod => $ocLazyLoad.load(mod.MY_APPLICANTS_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }
};

const applicantEditOrganization = {
    name: 'applicant.organization',
    url: 'organization/',
    component: 'applicantOrganization',
    text: 'Создать заявителя - Юридическое лицо',
    
    resolve: {},

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./my-applicants.module")
        .then(mod => $ocLazyLoad.load(mod.MY_APPLICANTS_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }
};



export {
    applicantEditIndex,
    applicantEditIndividual,
    applicantEditSelfEmployed,
    applicantEditOrganization
};


// WEBPACK FOOTER //
// ./src/components/desktop/my-applicants/applicant.module.states.js